"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFrameStatus = exports.EPlayState = void 0;
var EPlayState;
(function (EPlayState) {
    EPlayState["PLAY"] = "play";
    EPlayState["STOP"] = "stop";
    EPlayState["PAUSE"] = "pause";
})(EPlayState = exports.EPlayState || (exports.EPlayState = {}));
var EFrameStatus;
(function (EFrameStatus) {
    EFrameStatus["LOADING"] = "loading";
    EFrameStatus["ENABLED"] = "enabled";
})(EFrameStatus = exports.EFrameStatus || (exports.EFrameStatus = {}));
//# sourceMappingURL=types.js.map